import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonPage,
  IonTitle,
  IonToolbar
} from "@ionic/react";
import { chevronBack } from "ionicons/icons";
import QuoQuestProfileCard from "../components/QuoQuestProfileCard";
import QuoQuestLevelCard from "../components/QuoQuestLevelCard";
import { useQuestsStore } from "../stores/quests.store";

const QuoQuestLevels = () => {
  const levels = useQuestsStore(state => state.levels);
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton routerLink="/quest">
              <IonIcon className="text-white" icon={chevronBack} />
            </IonButton>
          </IonButtons>
          <IonTitle className="capitalize font-normal pt-4">QuoQuest</IonTitle>
        </IonToolbar>
        <IonToolbar className="p-2">
          <QuoQuestProfileCard />
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <div className="flex flex-col h-full px-4 mt-6">
          <h2 className="text-2xl font-semibold px-2 py-2">Quests</h2>
          <div className="flex flex-col gap-1">
            {levels.map(level => (
              <QuoQuestLevelCard level={level} key={level.level} />
            ))}
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default QuoQuestLevels;
